// src/utils/sessionUnlock.js
// Session-only unlock system with persistent hash code support

// ─── Plain functions (usable anywhere) ───────────────────────────

export function unlock(key) {
  sessionStorage.setItem(`unlock_${key}`, 'true');
  window.dispatchEvent(new CustomEvent('arcade-unlock', { detail: { key } }));
}

export function isUnlocked(key) {
  return sessionStorage.getItem(`unlock_${key}`) === 'true';
}

export function generateUnlockHash(key) {
  const existing = localStorage.getItem(`hash_${key}`);
  if (existing) return existing;

  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  const hash = Array.from(array)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

  localStorage.setItem(`hash_${key}`, hash);
  localStorage.setItem(`hashmap_${hash}`, key);

  return hash;
}

export function resolveHash(input) {
  const cleaned = input.trim().toLowerCase();
  const key = localStorage.getItem(`hashmap_${cleaned}`);
  return key || null;
}

// ─── React hook (backward-compatible wrapper) ────────────────────

export function useSessionUnlock() {
  return { unlock, isUnlocked, generateUnlockHash, resolveHash };
}